import { jsx as _jsx } from "react/jsx-runtime";
import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';
const statusColorMap = {
    APPLIED: 'warning',
    APPROVED: 'info',
    ACTIVE: 'success',
    REJECTED: 'error',
};
const ApplicationStatusChip = ({ status }) => {
    const { t } = useTranslation();
    return (_jsx(Chip, { label: t(`applications.status.${status}`), color: statusColorMap[status], size: "small", variant: "outlined" }));
};
export default ApplicationStatusChip;
